/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  vertical-align: middle;
  height: calc(24rem/14);
  width: calc(24rem/14);
}

:host > svg {
  height: 100%;
  width: 100%;
}`;
export { style };
//# sourceMappingURL=Icon.style.js.map